export default __webpack_public_path__ + "static/media/line-app.3c783b98.png";